<style scoped>
.margin-l-r {
    margin: 0 10px;
}
.margin-l {
    margin-right: 10px;
}
.margin-bottom {
    margin-bottom: 10px;
}
</style>
<template>
  <div>
    <div class="line">
      <Button
        v-if="(inGroup('GROUP_FIN', 'GROUP_HR') && is_formal) || inGroup('GROUP_EXPORT_CUSTOMER')"
        class="margin-l"
        icon="md-download"
        @click="showModal('customer_export')"
      >
        员工数据导出
      </Button>
      <space />
      <Button
        v-if="(inGroup('GROUP_HR') && is_formal)"
        class="margin-l-r"
        icon="md-download"
        @click="showModal('recruit_need_export')"
      >
        招聘需求导出
      </Button>
      <!--            <Button icon="md-download" @click="showModal('expense_write_off_export')" v-if="inGroup('GROUP_FIN')">充值冲销导出</Button>-->
      <space />
      <Button
        v-if="inGroup('GROUP_FIN')"
        class="margin-l-r"
        icon="md-download"
        @click="showModal('expense_group_export')"
      >
        费用导出
      </Button>
      <space />
      <Button
        v-if="inGroup('GROUP_FIN')"
        class="margin-l-r"
        icon="md-download"
        @click="showModal('invoice_export')"
      >
        发票导出
      </Button>
      <space />
      <Button
        v-if="inGroup('GROUP_FIN')"
        class="margin-l-r"
        icon="md-download"
        @click="showModal('contract_export')"
      >
        合同导出
      </Button>
      <space />
      <Button
        v-if="inGroup('GROUP_FIN')"
        class="margin-l-r"
        icon="md-download"
        @click="showModal('outsource_contract_export')"
      >
        云账户合同导出
      </Button>
      <space />
      <Button
        v-if="checkWageExport"
        class="margin-l-r"
        icon="md-download"
        @click="showModal('wage_export')"
      >
        工资汇总导出
      </Button>
      <space />
      <Button
        v-if="inGroup('GROUP_FIN') && is_formal"
        class="margin-l-r"
        icon="md-download"
        @click="showModal('customer_expense_type_export')"
      >
        员工费用科目导出
      </Button>
    </div>
    <div class="hr" />
    <div class="line">
      <Button
        icon="md-refresh"
        class="margin-bottom"
        :loading="loading"
        @click="refreshList"
      >
        刷新列表
      </Button>
    </div>
    <div class="line">
      <Table
        size="small"
        :columns="columns"
        :data="records"
        :loading="loading"
      />
    </div>
    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
    <CustomerExport
      ref="customer_export"
      @done="recordUpdate"
    />
    <RecruitNeedExport
      ref="recruit_need_export"
      @done="recordUpdate"
    />
    <ExpenseWriteOffExport
      ref="expense_write_off_export"
      @done="recordUpdate"
    />
    <ExpenseGroupExport
      ref="expense_group_export"
      @done="recordUpdate"
    />
    <InvoiceExport
      ref="invoice_export"
      @done="recordUpdate"
    />
    <ContractExport
      ref="contract_export"
      @done="recordUpdate"
    />
    <OutsourceContractExport
      ref="outsource_contract_export"
      @done="recordUpdate"
    />
    <WageExport
      ref="wage_export"
      @done="recordUpdate"
    />
    <CustomerExpenseTypeExport
      ref="customer_expense_type_export"
      @done="recordUpdate"
    />
  </div>
</template>
<script :route="['/resource/export','/resource/hrExport']">
  import CustomerExport from '../hr/customer_export';
  import RecruitNeedExport from './export_components/recruit_need';
  import ExpenseWriteOffExport from './export_components/expense_write_off_export';
  import ExpenseGroupExport from './export_components/expense_group_export';
  import InvoiceExport from './export_components/invoice_export';
  import ContractExport from './export_components/contract_export';
  import OutsourceContractExport from './export_components/outsource_contract_export';
  import WageExport from './export_components/wage_record';
  import CustomerExpenseTypeExport from './export_components/customer_expense_type_export';
  export default {
    /* router_info_start */
    router_info: ['/resource/export', '/resource/hrExport'],
    /* router_info_end */

    components: {
      CustomerExport, RecruitNeedExport, ExpenseWriteOffExport,
      ExpenseGroupExport, InvoiceExport, ContractExport,
      OutsourceContractExport, WageExport, CustomerExpenseTypeExport
    },
    data() {
      return {
        loading: false,
        params: {
          page: 1,
          per_page: 15,

        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 1
        },
        records: [],
        columns: [
          {
            title: '展开',
            type: 'expand',
            align: 'center',
            width: 50,
            render: (h, params) => {
              const row = params.row;
              return h('div', row.result || '-');
            }
          },
          {
            title: '导出类型',
            key: 'name',
            align: 'center'
          },
          {
            title: '文件',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              if (row.filename) {
                return h('div', {
                  'class': {
                    link: true
                  },
                  on: {
                    click: () => {
                      this.downloadFile(row.id);
                    }
                  }
                }, row.filename);
              } else {
                return h('span', '-');
              }
            }
          },
          {
            title: '状态',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const status = params.row.status;
              let ret = '';
              switch (status) {
              case 0:
                ret = [
                  h('Spin', {
                    style: {
                      display: 'inline-block',
                      verticalAlign: 'bottom'
                    }
                  }),
                  h('span', {
                    'class': {
                      'color-info': true
                    }
                  }, '处理中...')
                ];
                break;
              case 1:
                ret = [
                  h('span', {
                    'class': {
                      'color-success': true
                    }
                  }, '完成')];
                break;
              case 2:
                ret = [h('span', {
                  'class': {
                    'color-error': true
                  }
                }, '失败')];
                break;
              default:
                ret = '未定义状态';
              }
              return h('div', ret);
            }
          },
          {
            title: '导出时间',
            align: 'center',
            width: 150,
            key: 'created_at',
            render: (h, params) => {
              const row = params.row;
              return h('Time', {
                props: {
                  time: new Date(row.created_at),
                  type: "datetime"
                }
              })
            }
          },
          {
            title: '备注',
            align: 'center',
            tooltip: true,
            key: 'remark'
          }
        ]
      }
    },
    computed: {
      checkWageExport() {
        const current_hash = this.$store.state.hash_authority || {}
        return current_hash.wage_export_fin
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      is_formal() {
        return this.cur_customer.is_formal;
      },
    },
    created() {
      this.getExportRecords(true);
    },
    mounted() {
      this.grand = this.$router.beforeEach((to, from, next) => {
        if (to.path === from.path) {
          return
        }
        if (to.fullPath.includes('/resource/export') || to.fullPath.includes('/resource/hrExport')) {
          this.getExportRecords(true);
        }
        next()
      })
      //
    },
    beforeDestroy() {
      // 注销路由守卫
      this.grand()
    },
    methods: {
      inGroup() {
        const len = arguments.length;
        for (let i = 0; i < len; i++) {
          if (this.cur_customer.groups && this.cur_customer.groups.indexOf(arguments[i]) > -1) {
            return true;
          }
        }
        return false;
      },
      showModal(name) {
        this.$refs[name].show();
      },
      recordUpdate() {
        this.$Message.success('导出申请已提交');
        setTimeout(() => {
          this.refreshList();
        }, 1500);
      },
      refreshList() {
        this.pageChange(1);
      },
      pageChange(page) {
        this.params.page = page;
        this.getExportRecords(true);
      },
      getExportRecords(show_loading) {
        show_loading && (this.loading = true);
        Util.ajax.get(Util.api.export_list, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            const data = res.data;
            this.records = data.records;
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
          } else {
            //失败
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
          this.checkPendingExport();
        });
      },
      checkPendingExport() {
        clearInterval(this.update_status_timer);
        let has_pending = false;
        const len = this.records.length;
        for (let i = 0; i < len; i++) {
          const record = this.records[i];
          if (record.status === 0) {
            has_pending = true;
            break;
          }
        }
        if (has_pending) {
          this.update_status_timer = setInterval(() => {
            this.getExportRecords(false);
          }, 4000);
        }
      },
      downloadFile(record_id) {
        if (this.downloading) return;
        this.downloading = true;
        Util.ajax.get(Util.api.export_file_url, {
          params: {
            id: record_id
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            const data = res.data;
            window.open(data.url, '_blank');
          } else {
            //失败
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.downloading = false;
        });
      }
    }
  }
</script>
